function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.003 11l-1.858.9M5.865 11.9L3.997 11M18.143 11.898l-.755-3.611a2.252 2.252 0 00-2.204-1.79H8.91c-1.046 0-1.954.72-2.192 1.738l-.857 3.663",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.452 6.497l-.35-1.672a1.043 1.043 0 00-1.02-.829h-2.119c-.484 0-.904.333-1.014.804l-.396 1.697M7.999 18.28v1.723a1 1 0 01-1 1H4.996a1 1 0 01-1-1V17.6M20.004 17.6v2.403a1 1 0 01-1 1h-2.002a1 1 0 01-1-1V18.28",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.503 16.278V14.6a2.701 2.701 0 00-2.7-2.702H6.196a2.701 2.701 0 00-2.7 2.702v1.678a2 2 0 002 2.001h13.005c1.106 0 2.001-.896 2.001-2z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.331 14.861h.946M16.724 14.861h.945",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTaxi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgTaxi;